/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import {
  PDFDownloadLink,
} from "@react-pdf/renderer";
import React,{useEffect} from "react";
import GlobalTable from "../../../components/global-table";
import { Button, InputField, Typography } from "../../../ppui";
import {
  ContentLayout,
  ContentTable,
} from "../../style";
import { AttendanceHeaders } from "./attendancereport.data";
import AttendancePdf from "./pdf-report";
import useAttendanceReportService from "./use-attendance-report-service";

function EpfReport() {
  const {
    attendanceReportListData,
    attendenceReportInputs,
    handleChange,
    handleNextPage,
    handlePreviousPage,
    handleRowsPerPageChange,
    rowsPerPage,
    currentPage,
    totalPages,
    searchQuery,
    setSearchQuery,
    fetchAttendanceReportPdf,
    attendenceReportPDFData,
    attendenceSummary,
    organizationInfo,
    dataFetched,
    loadingAllSalaryReport,

} = useAttendanceReportService();

const handleExportClick = async () => {
    await fetchAttendanceReportPdf();
  };

  useEffect(() => {
    handleExportClick()
  }, [attendenceReportInputs])
  const orgInitials = organizationInfo?.org_name?.split(' ').map(word => word[0]?.toUpperCase()).join('');

  return (
    <>
      <ContentLayout>
        <ContentTable>
          <GlobalTable
            headers={AttendanceHeaders(currentPage, rowsPerPage)}
            rows={attendanceReportListData}
            ActiveSort={false}
            searchBox={true}
            columnManagement={false}
            avatar={true}
            stickyHeader="true"
            rowsPerPage={rowsPerPage}
            currentPage={currentPage}
            totalPages={totalPages}
            handleNextPage={handleNextPage}
            handlePreviousPage={handlePreviousPage}
            handleRowsPerPageChange={handleRowsPerPageChange}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            actionLeft={
              <>
              <Typography variant="h5" mb="0">
              {dataFetched && attendenceSummary?.total_employee} Employees Attendance Report {dataFetched && `of ${new Date(attendenceReportInputs.report_month).toLocaleString('en-US', { month: 'long', year: 'numeric' })}`}
                {/* {dataFetched && esiReportSummary?.total_esi_member} Employees ESI Report {dataFetched && `of ${getMonthInStringNotOneIndexBased(esiReportPDFData[0]?.month)} ${esiReportPDFData[0]?.year}`} */}
                
              </Typography>
                
              </>
            }
            actionRight={
              <>
              <InputField
                  label="Report Month"
                  name="month"
                  type="month"
                  placeholder="Type Here..."
                  valueSinc
                  value={attendenceReportInputs?.report_month}
                  onChange={(e)=>handleChange(e.target.value,"report_month")}
                  onKeyDown={e => e.preventDefault()}
                />
                {dataFetched ? (
            <PDFDownloadLink
              document={
                <AttendancePdf
                  organizationInfo = {organizationInfo}
                  attendenceSummary = {attendenceSummary}
                  attendenceReportPDFData = {attendenceReportPDFData}
                  attendenceReportInputs = {attendenceReportInputs}
                />
              }
              fileName={`${orgInitials}-attendance-report.pdf`}
            >
              {/* {({ loading }) => (loading ? 'Loading document...' : 'Download PDF')} */}
              <Button
                color="primary"
                variant="contained"
                onClick={handleExportClick}
                loading={loadingAllSalaryReport}
                disabled={attendanceReportListData.length > 0 ? false : true}
              >
                Export
              </Button>
            </PDFDownloadLink>
          ):<Button
          color="primary"
          variant="contained"
          disabled={ true}
        >
          Export
        </Button>}
              </>
            }
          />
        </ContentTable>
      </ContentLayout>
    </>
  );
};

export default EpfReport;
